module.exports = __webpack_public_path__ + "media/images/svg/robles_sphere-c500bb2875c61004455c5b479bf9f7cd.svg";